import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as myGlobals from "app/modelos/globales.modelo";
import { cVideollamadaData } from "app/modelos/plataforma.modelo";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class atmConnectService {
  private authEndpoint: string =
    myGlobals.getAtmConnectConnectionParam().AuthEndpoint;
  private Endpoint: string = myGlobals.getAtmConnectConnectionParam().Endpoint;

  constructor(protected _oHttp: HttpClient) {}

  obtainToken(): Observable<any> {
    const body = new HttpParams()
      .set("grant_type", myGlobals.getAtmConnectConnectionParam().GrantType)
      .set("client_id", myGlobals.getAtmConnectConnectionParam().User)
      .set("client_secret", myGlobals.getAtmConnectConnectionParam().Password)
      .set("scope", myGlobals.getAtmConnectConnectionParam().Scope);

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      skip: "",
    });

    return this._oHttp.post(this.authEndpoint, body.toString(), { headers });
  }

  SolicitarVideollamada(
    motivo: string,
    nif: string,
    correo: string,
    fevento: string,
    devento: number,
  ): Observable<cVideollamadaData> {
    return this.obtainToken().pipe(
      switchMap((res) => {
        const access_token = res.access_token;
        const type = res.token_type;

        const headers = new HttpHeaders({
          skip: "",
          Authorization: `${type} ${access_token}`,
        });

        const body = {
          idcliente: myGlobals.IdClienteActivo().toString(),
          idaplicacion: "27",
          motivo: motivo,
          usuario: nif,
          correo: correo,
          fevento: fevento,
          devento: devento,
          url_atm: myGlobals.getAtmConnectConnectionParam().url_atm,
          remitente: myGlobals.getNombreCliente(),
        };

        return this._oHttp.post<cVideollamadaData>(
          this.Endpoint + "/chime_request_crear",
          body,
          { headers },
        );
      }),
    );
  }
}
